var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card mt-2" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card__content" }, [
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v("T. Comp.")]),
              _vm._v(" "),
              _c("th", [_vm._v("Vendedor")]),
              _vm._v(" "),
              _c("th", [_vm._v("F. Emisión")]),
              _vm._v(" "),
              _c("th", [_vm._v("Motivo")]),
              _vm._v(" "),
              _c("th", [_vm._v("# Comp.")]),
              _vm._v(" "),
              _c("th", [_vm._v("Cliente/Transp.")]),
              _vm._v(" "),
              _c("th", [_vm._v("Identificación")]),
              _vm._v(" "),
              _c("th", [_vm._v("Comp. Afect./Prof.")]),
              _vm._v(" "),
              _vm.conDetalles ? _c("th", [_vm._v("Detalles")]) : _vm._e(),
              _vm._v(" "),
              _vm.conAbonos ? _c("th", [_vm._v("Abonos")]) : _vm._e(),
              _vm._v(" "),
              _c("th", [_vm._v("Tot. Sin Imp.")]),
              _vm._v(" "),
              _c("th", [_vm._v("IVA")]),
              _vm._v(" "),
              _c("th", [_vm._v("ICE")]),
              _vm._v(" "),
              _c("th", [_vm._v("IRBPNR")]),
              _vm._v(" "),
              _c("th", [_vm._v("Ret. IVA")]),
              _vm._v(" "),
              _c("th", [_vm._v("Ret. Renta")]),
              _vm._v(" "),
              _c("th", [_vm._v("Total")]),
              _vm._v(" "),
              _c("th", [_vm._v("Tot. Pagado")]),
              _vm._v(" "),
              _c("th", [_vm._v("Saldo")]),
              _vm._v(" "),
              _c("th", [_vm._v("Estado")]),
              _vm._v(" "),
              _c("th", [_vm._v("Acciones")])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.registros, function(registro) {
              return _c("tr", { key: registro.id_comprobante }, [
                _c("td", [
                  _vm._v(_vm._s(registro.tipo_comprobante.descripcion))
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      registro.vendedor !== null ? registro.vendedor.nombre : ""
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(registro.fecha_emision))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(registro.descripcion_motivo))]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      staticClass: "btn-info btn--text",
                      attrs: {
                        target: "_blank",
                        href:
                          _vm.url +
                          "/comprobantes?id_comprobante=" +
                          registro.id_comprobante
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(registro.numero_documento) +
                          "\n              "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      registro.cliente !== null ? registro.cliente.nombre : ""
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(registro.numero_identificacion))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(registro.numeracion_comp_venta))]),
                _vm._v(" "),
                _vm.conDetalles
                  ? _c("td", [
                      _c("div", { staticClass: "table-responsive" }, [
                        registro.id_tipo_comprobante == "07"
                          ? _c("table", [
                              _vm._m(1, true),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(registro.impuestos, function(
                                  impuesto,
                                  index
                                ) {
                                  return _c("tr", { key: index }, [
                                    _c("td", [
                                      _vm._v(_vm._s(impuesto.num_doc_sustento))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(impuesto.fecha_emision_sustento)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(impuesto.periodo_fiscal))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(impuesto.id_tarifa))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.moneyFormat(
                                            impuesto.base_imponible
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(impuesto.impuesto.descripcion)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.moneyFormat(impuesto.tarifa))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.moneyFormat(impuesto.valor))
                                      )
                                    ])
                                  ])
                                }),
                                0
                              )
                            ])
                          : registro.id_tipo_comprobante == "06"
                          ? _c("table", [
                              _vm._m(2, true),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(registro.detalles_gr, function(
                                  detalle,
                                  index
                                ) {
                                  return _c("tr", { key: index }, [
                                    _c("td", [
                                      _vm._v(_vm._s(detalle.num_doc_sustento))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(detalle.fecha_emi_doc_sustento)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(detalle.num_aut_doc_sustento)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          detalle.identificacion_destinatario
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          detalle.razon_social_destinatario
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(detalle.motivo_traslado))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(detalle.direccion_destino))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "div",
                                        { staticClass: "table-responsive" },
                                        [
                                          _c("table", [
                                            _vm._m(3, true),
                                            _vm._v(" "),
                                            _c(
                                              "tbody",
                                              _vm._l(detalle.items, function(
                                                item,
                                                index
                                              ) {
                                                return _c(
                                                  "tr",
                                                  { key: index },
                                                  [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.codigo_interno
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(item.descripcion)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.decimalFormat(
                                                            item.cantidad
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          ])
                                        ]
                                      )
                                    ])
                                  ])
                                }),
                                0
                              )
                            ])
                          : _c("table", [
                              _vm._m(4, true),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(registro.items, function(item, index) {
                                  return _c("tr", { key: index }, [
                                    _c("td", [_vm._v(_vm._s(item.id_item))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(item.descripcion_item))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.decimalFormat(item.cantidad))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.moneyFormat(item.precio_unitario)
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.moneyFormat(
                                            item.precio_sin_subsidio
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.moneyFormat(item.valor_subsidio)
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.moneyFormat(item.descuento))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.moneyFormat(
                                            item.precio_total_sin_imp
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                }),
                                0
                              )
                            ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.conAbonos
                  ? _c("td", [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: registro.abonos.length > 0,
                              expression: "registro.abonos.length > 0"
                            }
                          ],
                          staticClass: "table-responsive"
                        },
                        [
                          _c("table", [
                            _vm._m(5, true),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(registro.abonos, function(abono, index) {
                                return _c("tr", { key: abono.id }, [
                                  _c("td", [_vm._v(_vm._s(abono.fecha_abono))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(abono.descripcion_tipo_abono))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.moneyFormat(abono.valor)))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.moneyFormat(
                                          _vm.calcularSaldo(
                                            registro.valor_total,
                                            registro.abonos,
                                            index
                                          )
                                        )
                                      )
                                    )
                                  ])
                                ])
                              }),
                              0
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: parseFloat(registro.saldo) > 0,
                              expression: "parseFloat(registro.saldo) > 0"
                            }
                          ],
                          staticClass: "table-responsive"
                        },
                        [
                          _c("table", [
                            _vm._m(6, true),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(registro.formas_pago, function(
                                formaPago,
                                index2
                              ) {
                                return _c(
                                  "tr",
                                  {
                                    key: index2,
                                    class: {
                                      "tr--canceled": _vm.pagoExpirado(
                                        formaPago
                                      ),
                                      "tr--pending": _vm.pagoExpectante(
                                        formaPago
                                      )
                                    }
                                  },
                                  [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(formaPago.forma_pago.descripcion)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(formaPago.plazo) +
                                          " " +
                                          _vm._s(formaPago.unidad_tiempo)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(formaPago.fecha_maxima_pago)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.diasRestantes(formaPago))
                                      )
                                    ])
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm.moneyFormat(registro.total_sin_impuestos)))
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.moneyFormat(registro.valor_iva)))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.moneyFormat(registro.valor_ice)))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm.moneyFormat(registro.valor_irbpnr)))
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.moneyFormat(registro.total_iva)))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm.moneyFormat(registro.total_renta)))
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(registro.anulado === "S" ? "*" : "") +
                      _vm._s(_vm.moneyFormat(registro.valor_total))
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm.moneyFormat(registro.total_pagado)))
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.moneyFormat(registro.saldo) +
                        (parseFloat(registro.saldo) > 0
                          ? " (Pendiente)"
                          : " (Pagado)")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(registro.descripcion_estado))]),
                _vm._v(" "),
                _c("td", [
                  registro.id_estado_comprobante === "AUT"
                    ? _c(
                        "a",
                        {
                          staticClass: "btn-success btn--text",
                          attrs: {
                            target: "_blank",
                            href:
                              _vm.url +
                              "/comprobantes/" +
                              registro.id_comprobante +
                              "/xml"
                          }
                        },
                        [_c("i", { staticClass: "fa fa-file-excel-o" })]
                      )
                    : _vm._e()
                ])
              ])
            }),
            0
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.registros.lenght === 0
      ? _c("p", [
          _c("strong", [
            _vm._v("No se ha encontrado registros en la consulta.")
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Resultados de la Consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("# Doc. Sust.")]),
        _vm._v(" "),
        _c("th", [_vm._v("F. Emi. Doc. Sust.")]),
        _vm._v(" "),
        _c("th", [_vm._v("P. Fiscal")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cod. Ret.")]),
        _vm._v(" "),
        _c("th", [_vm._v("B. Imponible")]),
        _vm._v(" "),
        _c("th", [_vm._v("Impuesto")]),
        _vm._v(" "),
        _c("th", [_vm._v("Porcentaje")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("# Doc.")]),
        _vm._v(" "),
        _c("th", [_vm._v("F. Emi.")]),
        _vm._v(" "),
        _c("th", [_vm._v("# Aut.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Id. Dest.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Dest.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Mot. Traslado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Destino")]),
        _vm._v(" "),
        _c("th", [_vm._v("Items")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Cod. Item")]),
        _vm._v(" "),
        _c("th", [_vm._v("Descripción")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Cod. Item")]),
        _vm._v(" "),
        _c("th", [_vm._v("Desc. Item")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cant.")]),
        _vm._v(" "),
        _c("th", [_vm._v("P. Unit.")]),
        _vm._v(" "),
        _c("th", [_vm._v("P. Sin Subs.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Subsidio")]),
        _vm._v(" "),
        _c("th", [_vm._v("Descuento")]),
        _vm._v(" "),
        _c("th", [_vm._v("P. Tot. Sin Imp.")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Fecha de abono")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tipo de abono")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor")]),
        _vm._v(" "),
        _c("th", [_vm._v("Saldo")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Forma de pago")]),
        _vm._v(" "),
        _c("th", [_vm._v("Plazo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha máxima de pago")]),
        _vm._v(" "),
        _c("th", [_vm._v("Diferencia de días")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b061d14", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b061d14","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/TablaReporteVentas.vue
// module id = 490
// module chunks = 0